import type { SynthConfig } from "./types";

export const DEFAULT_SYNTH_CONFIG: SynthConfig = {
    eventsEnabled: true,
    oneOutput: false,
    audioNodeCreators: undefined
};

export const ALL_CHANNELS_OR_DIFFERENT_ACTION = -1;
